module.exports = __webpack_public_path__ + "img/genesis-drop-impostor.3a4fa950.webp";